export default __webpack_public_path__ + "static/media/2.da4c7d84.jpg";